import instanceAxios from './axiosConfig';
import { URL} from '../utility/util';

const getGiftCard = (contactId, initialContactId) => {
    let req = URL.PARAMS.GET_GIFT_CARD;
    req.data.contactId =contactId;
    req.data.initialContactId = initialContactId;

     return new Promise((resolve, reject)=>{
        instanceAxios.post('/mso-chat', req)
        .then((response)=>{
            if(response.data.status === 200) {
                resolve(response.data.data);
            } else {
                reject(response.data)
            }
        })
        .catch((error)=>{
            reject(error);
        })
     });
}

export {getGiftCard};